<template>
  <div id="container" class="cs_st service_introduce">
    <div class="background c_banner">
      <div class="section fill intro c_wrap">
        <div class="background_pc">
          <img
            src="@/assets/images/new_detailpage/company/banner_logo.png"
            alt=""
            class="bn_logo"
          />
          <p>
            캠퍼스북은 학습자의 편의를 우선으로 탄생한<br />
            대학교재 <em>전자책 유통 플랫폼</em>입니다.
          </p>
        </div>
        <div id="background_mb">
          <img
            src="@/assets/images/new_detailpage/company/banner_logo.png"
            alt=""
            class="bn_logo"
          />
          <p>
            캠퍼스북은 학습자의 편의를 <br />우선으로 탄생한 대학교재 <br /><em
              >전자책 유통 플랫폼</em
            >입니다.
          </p>
          <img
            src="@/assets/images/new_detailpage/company/compant_banner_mb.png"
            alt=""
            class="bn_img"
          />
        </div>
      </div>
    </div>
    <div class="section_wrap">
      <div class="section1">
        <div class="section_box">
          <img
            src="@/assets/images/new_detailpage/company/section1.png"
            alt=""
            class="bn_logo"
          />
          <div class="section_cont pc_p">
            <h4>국내 유수 출판사들의 대학 교재 e-Book을 캠퍼스북에서</h4>
            <p>
              이제 두껍고 무거운 전공 도서를 내 손안의 디지털 서재에서 언제
              어디서나 펼쳐볼 수 있습니다. <br />
              <em>필기, 검색, 웹페이지 링크, 이미지·표 삽입 등</em> 학습에
              특화된 기능들을 만나보세요.<br />
              보다 쉽고 편한 학습을 위해 캠퍼스북이 여러분의 디지털 학습
              파트너가 되어드리겠습니다.
            </p>
          </div>
          <div class="section_cont mb_p">
            <h4>국내 유수 출판사들의 대학 교재 <br />e-Book을 캠퍼스북에서</h4>
            <p>
              이제 두껍고 무거운 전공 도서를 <br />내 손안의 디지털 서재에서<br />
              언제 어디서나 펼쳐볼 수 있습니다. <br />
              <em>필기, 검색, 웹페이지 링크, 이미지·표 삽입 등</em> <br />학습에
              특화된 기능들을 만나보세요.<br />
              보다 쉽고 편한 학습을 위해 캠퍼스북이<br />
              여러분의 디지털 학습 파트너가 되어드리겠습니다.
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="section2">
        <div class="section_box">
          <h4 class="pc_p">
            ONLY IN
            <em>CAMPUS BOOK</em>
            <p>
              SDP(Smart Digital Publishing) 솔루션을 기반으로 학술서적에
              최적화된<br />
              전자책을 제작 및 서비스합니다.
            </p>
          </h4>
          <h4 class="mb_p">
            ONLY IN<br />
            <em>CAMPUS BOOK</em>
            <p>
              SDP(Smart Digital Publishing) 솔루션을<br />
              기반으로 학술서적에 최적화된<br />
              전자책을 제작 및 서비스합니다.
            </p>
          </h4>
          <div class="section_cont">
            <ul>
              <li>
                <img
                  src="@/assets/images/new_detailpage/company/section2-1.png"
                  alt=""
                />
                <p>
                  일반구매 (소장) 외에도<br />
                  6개월, 12개월 단위의 <br />
                  저렴한 장기 대여 가능
                </p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/company/section2-2.png"
                  alt=""
                />
                <p>
                  PC나 스마트기기의 <br />저장공간을 활용하지 않는<br />
                  온라인 스트리밍 최적화 환경
                </p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/company/section2-3.png"
                  alt=""
                />
                <p>
                  대학 전공 수업에<br />
                  특화된 뷰어 기능 제공<br />
                  (검색 기능 , 메모 및 노트 기능 등)
                </p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/company/section2-4.png"
                  alt=""
                />
                <p>
                  모든 교·강사들의<br />
                  빠르고 편리한 교재 선택을<br />
                  위한 전자책 증정 서비스 제공
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyAbout',
  data() {
    return {}
  },
  computed: {
    viewerSwiper() {
      return this.$refs.viewerSwiper.$swiper
    },
    ebookSwiper() {
      return this.$refs.ebookSwiper.$swiper
    }
  },
  mounted() {
    // let that = this
    // that.mySwiper.on('init', () => {
    //   that.getActiveIndex(this)
    //   console.log(that.getActiveIndex(this))
    // })
  },

  methods: {
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    },
    closeListMenu() {
      this.showListMenu = false
    },
    activeIndexChange(i) {
      console.log(i)
    },
    slideChangeEbook() {
      this.eBookPg = parseInt(this.ebookSwiper.activeIndex) + 1
    },
    slideChangeViewer() {
      this.viewerPg = parseInt(this.viewerSwiper.activeIndex) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'NanumSquare';
  font-weight: 400;
  src: url('../../../src/assets/fonts/NanumSquareR.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 300;
  src: url('../../../src/assets/fonts/NanumSquareL.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 700;
  src: url('../../../src/assets/fonts/NanumSquareB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 800;
  src: url('../../../src/assets/fonts/NanumSquareEB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('ttf');
}

body,
h1,
h4,
p {
  font-family: 'pretendard-light';
}

em {
  color: #00b8ac;
}

img {
  width: 100%;
}

.mb_p {
  display: none;
}

#background_mb {
  display: none;
}
.section.fill {
  width: 100%;
  max-width: 1120px;
  background: none;
}

.cs_st.service_introduce .background {
  position: relative;
  background: url('../../assets/images/new_detailpage/company/company_banner.jpg')
    top center no-repeat;
  .intro.fill {
    height: 630px;
    background: none;
    .bn_logo {
      width: 500px;
      padding-top: 230px;
    }
    p {
      font-size: 2.1em;
      padding-top: 30px;
      color: #2f2f2f;
      em {
        color: #005f8a;
        font-weight: 900;
      }
    }
  }
}

.section_wrap {
  text-align: center;
  .section_box {
    padding: 120px 0;
  }
  .section_cont {
    margin: 50px auto 0;
    max-width: 1120px;
  }
}

.section1 {
  color: #212121;
  img {
    max-width: 800px;
  }
  h4 {
    font-size: 29px;
    font-weight: 900;
  }
  p {
    padding-top: 15px;
    line-height: 33px;
    font-size: 20px;
    font-weight: bold;
  }
}

.section2 {
  background-color: #fcf18c;
  h4 {
    font-size: 50px;
    font-weight: 600;
    em {
      font-weight: 900;
    }
    p {
      color: #ff8431;
      font-size: 22px;
      margin-top: 10px;
      line-height: 32px;
    }
  }
  .section_cont {
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        font-weight: bold;
        width: 25%;
        img {
          max-width: 134px;
        }
        p {
          margin-top: 20px;
          font-size: 16px;
          color: #3e3a39;
          line-height: 27px;
        }
      }
    }
  }
}
@media (max-width: 1120px) {
  .cs_st.service_introduce .intro p {
    line-height: 36px;
  }
  .background .background_pc {
    padding-left: 30px;
  }
  .section_wrap > div {
    padding-left: 50px;
    padding-right: 50px;
  }
}
@media (max-width: 830px) {
  .cs_st.service_introduce .introduce_cont p {
    padding-top: 0;
  }
  .background_pc {
    display: none;
  }
  .section_wrap .pc_p {
    display: none;
  }
  .section_wrap .mb_p {
    display: block;
  }

  #background_mb {
    display: block;
  }

  .cs_st.service_introduce .background {
    background: none;
    background-color: #d2edff;
    height: 650px;
    padding-left: 20px;
    padding-right: 20px;
    #background_mb {
      .bn_logo,
      .bn_img {
        padding-top: 100px;
        max-width: 400px;
        width: 100%;
      }
      .bn_img {
        padding-top: 100px;
      }
      p {
        font-size: 22px;
        line-height: 35px;
      }
    }
  }
  .section_wrap > div {
    padding-left: 30px;
    padding-right: 30px;
    .section_box {
      padding: 60px 0;
    }
  }

  .section1 {
    img {
      width: 120%;
      margin-left: -30px;
    }
    h4 {
      margin-top: 20px;
      font-size: 22px;
      font-weight: 900;
    }
    p {
      line-height: 30px;
      font-size: 16px;
    }
  }
  .section2 {
    h4 {
      font-size: 44px;
      font-weight: 600;
      em {
        font-weight: 900;
      }
      p {
        color: #ff8431;
        font-size: 18px;
        margin-top: 10px;
        line-height: 30px;
      }
    }
    .section_cont {
      ul {
        li {
          margin-top: 50px;
          width: 100%;
          img {
            max-width: 116px;
          }
          p {
            font-size: 16px;
            color: #3e3a39;
            line-height: 27px;
          }
        }
        li:first-child {
          margin-top: 0px;
        }
      }
    }
  }
}
@media screen and (min-width: 831px) and (max-width: 1280px) {
  .c_banner {
    background-size: contain !important;
    > .c_wrap {
      height: 32.8125vw !important;
      .background_pc {
        img {
          width: 26.0416vw !important;
          min-width: 360px !important;
          padding-top: 11.97916vw !important;
        }
        > p {
          font-size: 1.675em !important;
        }
      }
    }
  }
}
</style>
